var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLobby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H36V42C36 42.5304 35.7893 43.0391 35.4142 43.4142C35.0391 43.7893 34.5304 44 34 44H8C7.46957 44 6.96086 43.7893 6.58579 43.4142C6.21071 43.0391 6 42.5304 6 42V24Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C15.2089 16 14.4355 15.7654 13.7777 15.3259C13.1199 14.8864 12.6072 14.2616 12.3045 13.5307C12.0017 12.7998 11.9225 11.9956 12.0769 11.2196C12.2312 10.4437 12.6122 9.73098 13.1716 9.17157C13.731 8.61216 14.4437 8.2312 15.2196 8.07686C15.9956 7.92252 16.7998 8.00173 17.5307 8.30448C18.2616 8.60723 18.8864 9.11993 19.3259 9.77772C19.7654 10.4355 20 11.2089 20 12C20.0001 12.5253 19.8967 13.0455 19.6957 13.5308C19.4947 14.0162 19.2001 14.4572 18.8286 14.8286C18.4572 15.2001 18.0162 15.4947 17.5308 15.6957C17.0455 15.8967 16.5253 16.0001 16 16",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16C36.2089 16 35.4355 15.7654 34.7777 15.3259C34.1199 14.8864 33.6072 14.2616 33.3045 13.5307C33.0017 12.7998 32.9225 11.9956 33.0769 11.2196C33.2312 10.4437 33.6122 9.73098 34.1716 9.17157C34.731 8.61216 35.4437 8.2312 36.2196 8.07686C36.9956 7.92252 37.7998 8.00173 38.5307 8.30448C39.2616 8.60723 39.8864 9.11993 40.3259 9.77772C40.7654 10.4355 41 11.2089 41 12C41.0001 12.5253 40.8967 13.0455 40.6957 13.5308C40.4947 14.0162 40.2001 14.4572 39.8286 14.8286C39.4572 15.2001 39.0162 15.4947 38.5308 15.6957C38.0455 15.8967 37.5253 16.0001 37 16",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23.0625C9.48574 21.5895 10.4238 20.3072 11.6806 19.3982C12.9374 18.4893 14.4489 18 16 18C17.5511 18 19.0626 18.4893 20.3194 19.3982C21.5762 20.3072 22.5143 21.5895 23 23.0625V24.75H9V23.0625Z",
    fill: "#AD4BD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22H6C4.89543 22 4 22.8954 4 24C4 25.1046 4.89543 26 6 26H36C37.1046 26 38 25.1046 38 24C38 22.8954 37.1046 22 36 22Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16C36.2089 16 35.4355 15.7654 34.7777 15.3259C34.1199 14.8864 33.6072 14.2616 33.3045 13.5307C33.0017 12.7998 32.9225 11.9956 33.0769 11.2196C33.2312 10.4437 33.6122 9.73098 34.1716 9.17157C34.731 8.61216 35.4437 8.2312 36.2196 8.07686C36.9956 7.92252 37.7998 8.00173 38.5307 8.30448C39.2616 8.60723 39.8864 9.11993 40.3259 9.77772C40.7654 10.4355 41 11.2089 41 12C40.9969 13.0599 40.5745 14.0755 39.825 14.825C39.0755 15.5745 38.0599 15.9969 37 16Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28H36V42.5C35.9999 42.8978 35.8418 43.2792 35.5605 43.5605C35.2792 43.8418 34.8978 43.9999 34.5 44C34.1022 43.9999 33.7208 43.8418 33.4395 43.5605C33.1582 43.2792 33.0001 42.8978 33 42.5V28Z",
    fill: "#199BE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28H41V42.5C40.9999 42.8978 40.8418 43.2792 40.5605 43.5605C40.2792 43.8418 39.8978 43.9999 39.5 44C39.1022 43.9999 38.7208 43.8418 38.4395 43.5605C38.1582 43.2792 38.0001 42.8978 38 42.5V28Z",
    fill: "#199BE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.271 28.64L31.226 20.133C31.687 19.4744 32.3 18.9366 33.013 18.5653C33.726 18.194 34.5181 18.0001 35.322 18H38C39.326 18.0001 40.5977 18.527 41.5354 19.4646C42.473 20.4023 42.9999 21.674 43 23V32.5C43.0009 32.8535 42.8765 33.1959 42.649 33.4665C42.4216 33.7371 42.1056 33.9185 41.7572 33.9784C41.4088 34.0383 41.0504 33.9729 40.7456 33.7938C40.4408 33.6147 40.2093 33.3335 40.092 33H38C38 32.7348 37.8946 32.4804 37.7071 32.2929C37.5196 32.1054 37.2652 32 37 32C36.7348 32 36.4804 32.1054 36.2929 32.2929C36.1054 32.4804 36 32.7348 36 33H33V24.666C33 24.5429 32.9607 24.423 32.8879 24.3238C32.8151 24.2245 32.7126 24.1511 32.5952 24.1141C32.4778 24.0771 32.3517 24.0784 32.2351 24.118C32.1185 24.1575 32.0176 24.2332 31.947 24.334L27.729 30.36C27.6161 30.5214 27.4724 30.659 27.3063 30.7649C27.1402 30.8707 26.9549 30.9429 26.7609 30.9771C26.5669 31.0114 26.3681 31.0071 26.1758 30.9646C25.9835 30.922 25.8014 30.8419 25.64 30.729C25.4786 30.6161 25.341 30.4724 25.2351 30.3063C25.1293 30.1402 25.0571 29.9549 25.0229 29.7609C24.9886 29.5669 24.9929 29.3681 25.0354 29.1758C25.078 28.9835 25.1581 28.8014 25.271 28.64Z",
    fill: "#199BE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M33 42.5V24.67C33.0009 24.5936 32.9865 24.5178 32.9576 24.447C32.9288 24.3762 32.8861 24.3119 32.8321 24.2579C32.778 24.2039 32.7138 24.1612 32.643 24.1324C32.5722 24.1035 32.4964 24.0891 32.42 24.09C32.3279 24.0876 32.2366 24.1083 32.1545 24.1503C32.0724 24.1922 32.0021 24.254 31.95 24.33L27.73 30.36C27.5921 30.5583 27.4081 30.7201 27.1939 30.8316C26.9796 30.9431 26.7415 31.0009 26.5 31C26.2255 31.0003 25.9562 30.9252 25.7214 30.783C25.4866 30.6408 25.2954 30.4368 25.1685 30.1934C25.0417 29.95 24.984 29.6764 25.0019 29.4025C25.0198 29.1286 25.1125 28.8648 25.27 28.64L29.92 22H28.7L24.45 28.07C24.071 28.6138 23.9234 29.2858 24.0397 29.9383C24.1559 30.5909 24.5265 31.1706 25.07 31.55C25.3391 31.738 25.6427 31.871 25.9633 31.9416C26.2839 32.0122 26.6153 32.0189 26.9385 31.9613C27.2617 31.9037 27.5704 31.783 27.8469 31.606C28.1234 31.4291 28.3623 31.1994 28.55 30.93L32 26V42.5C32.0002 43.0409 32.1756 43.5672 32.5 44H34C34.0936 43.9987 34.1871 43.992 34.28 43.98C33.9239 43.9295 33.5981 43.7518 33.3628 43.4798C33.1275 43.2077 32.9986 42.8597 33 42.5V42.5Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M33 42.5V24.67C33.0009 24.5936 32.9865 24.5178 32.9576 24.447C32.9288 24.3762 32.8861 24.3119 32.8321 24.2579C32.7781 24.2039 32.7138 24.1612 32.643 24.1324C32.5722 24.1035 32.4964 24.0891 32.42 24.09C32.3279 24.0876 32.2366 24.1083 32.1545 24.1503C32.0724 24.1922 32.0021 24.254 31.95 24.33L27.73 30.36C27.5921 30.5583 27.4081 30.7201 27.1939 30.8316C26.9796 30.9431 26.7415 31.0009 26.5 31C26.2255 31.0003 25.9562 30.9252 25.7214 30.783C25.4866 30.6408 25.2954 30.4368 25.1685 30.1934C25.0417 29.95 24.984 29.6764 25.0019 29.4025C25.0198 29.1286 25.1125 28.8648 25.27 28.64L29.92 22H29.31L24.86 28.35C24.7086 28.5658 24.6015 28.8095 24.5448 29.067C24.4882 29.3244 24.4831 29.5906 24.53 29.85C24.6242 30.3707 24.9186 30.8337 25.35 31.14C25.6888 31.372 26.0893 31.4974 26.5 31.5C26.8212 31.4986 27.1375 31.4208 27.4226 31.273C27.7078 31.1252 27.9537 30.9117 28.14 30.65L32.36 24.62C32.3659 24.6096 32.3748 24.6013 32.3855 24.5959C32.3961 24.5906 32.4082 24.5885 32.42 24.59C32.4307 24.5891 32.4415 24.5906 32.4516 24.5943C32.4617 24.598 32.4709 24.6038 32.4785 24.6115C32.4862 24.6191 32.492 24.6283 32.4957 24.6384C32.4994 24.6485 32.5009 24.6593 32.5 24.67V42.5C32.5 42.785 32.5617 43.0666 32.6808 43.3255C32.7999 43.5845 32.9736 43.8145 33.19 44H34C34.0936 43.9987 34.1871 43.992 34.28 43.98C33.9239 43.9295 33.5981 43.7518 33.3628 43.4798C33.1275 43.2077 32.9986 42.8597 33 42.5V42.5Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 40.5H15.25V32.5C15.2504 32.1023 15.4086 31.721 15.6898 31.4398C15.971 31.1586 16.3523 31.0004 16.75 31H19.75C20.1477 31.0004 20.529 31.1586 20.8102 31.4398C21.0914 31.721 21.2496 32.1023 21.25 32.5V40.5ZM16.25 39.5H20.25V32.5C20.2498 32.3674 20.1971 32.2404 20.1034 32.1466C20.0096 32.0529 19.8826 32.0002 19.75 32H16.75C16.6174 32.0002 16.4904 32.0529 16.3966 32.1466C16.3029 32.2404 16.2502 32.3674 16.25 32.5V39.5Z",
    fill: "#343434"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34H11C10.4477 34 10 34.4477 10 35V43C10 43.5523 10.4477 44 11 44H25C25.5523 44 26 43.5523 26 43V35C26 34.4477 25.5523 34 25 34Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21,
    y1: 42.505,
    x2: 21,
    y2: 25.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#D97218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#C46716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11.183,
    y1: 12,
    x2: 20.574,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#FDCB4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#F7C13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 290.464,
    y1: 8,
    x2: 365.592,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#FDCB4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#F7C13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 21,
    y1: 19.777,
    x2: 21,
    y2: 27.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#E9A144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#E28D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 348.912,
    y1: -2314.09,
    x2: 392.912,
    y2: -2270.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#FDCB4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#F7C13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 12.331,
    y1: 23.426,
    x2: 26.862,
    y2: 63.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8B3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802D10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobby);
export default __webpack_public_path__ + "static/media/lobby.4595673afdbde542b54035b7e446233a.svg";
export { ForwardRef as ReactComponent };